import { render, staticRenderFns } from "./EnablingTypeCategoriesRegistryEditForm.vue?vue&type=template&id=c7089626"
import script from "./EnablingTypeCategoriesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./EnablingTypeCategoriesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports